import {
  FETCH_PRICING_ANALYTICS,
  FETCH_PRICING_CONFIG,
  FETCH_PRICING_CONFIGS,
  FETCH_PRICING_LOADING,
  FETCH_PRICING_MAPS,
  FETCH_VARIANT_PRICING_CONTEXT,
} from "../Constants/types";

const initialState = {
  configs: [],
  currentConfig: {},
  variantContext: {},
  analytics: {},
  maps: [],
  isPricingLoading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_PRICING_LOADING:
      return {
        ...state,
        isPricingLoading: action.payload,
      };
    case FETCH_PRICING_CONFIGS:
      return {
        ...state,
        configs: action.payload || [],
      };
    case FETCH_PRICING_CONFIG:
      return {
        ...state,
        currentConfig: action.payload || {},
      };
    case FETCH_VARIANT_PRICING_CONTEXT:
      return {
        ...state,
        variantContext: action.payload || {},
      };
    case FETCH_PRICING_ANALYTICS:
      return {
        ...state,
        analytics: action.payload || {},
      };
    case FETCH_PRICING_MAPS:
      return {
        ...state,
        maps: action.payload || [],
      };
    default:
      return state;
  }
}
